<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Master/Order'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-shopping-cart"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              จัดการข้อมูลการสั่งซื้อ (Order)
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="orlKeyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก Invoice NO. งบประมาณ เช่น 700096, 700097"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>Invoice Date. :</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="Invoice Date. (วว/ดด/ปปปป)"
                      id="orlInvDate"
                      name="orlInvDate"
                      ref="orlInvDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>Supplier:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'orlVendorId'"
                    :name="'orlVendorId'"
                    :select2-options="orlVendorIdOptions"
                    v-model="orlVendorId"
                    ref="orlVendorIdSelect2"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="orlVendorId"
                    :multiple="true"
                    :load-options="LoadaOrlVendorIdOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>Quota:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'orlQuotaId'"
                    :name="'orlQuotaId'"
                    :select2-options="orlQuotaIdOptions"
                    v-model="orlQuotaId"
                    ref="orlQuotaIdSelect2"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="orlQuotaId"
                    :multiple="true"
                    :options="orlQuotaIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>Product:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'orlProductId'"
                    :name="'orlProductId'"
                    :select2-options="orlProductIdOptions"
                    v-model="orlProductId"
                    ref="orlProductIdSelect2"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="orlProductId"
                    :multiple="true"
                    :options="orlProductIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <!-- <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'orlInActiveStatus'"
                    :name="'orlInActiveStatus'"
                    :select2-options="orlInActiveStatusOptions"
                    v-model="orlInActiveStatus"
                    ref="orlInActiveStatusSelect2"
                  ></select2>
                </div>
              </div> -->
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="Order/Add"
                  tag="button"
                  title="เพิ่มข้อมูลการสั่งซื้อ "
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['MANAGE_MASTER', 'MANAGE_ORDER'])"
                >
                  <i class="fa fa-plus-circle"></i> เพิ่มข้อมูลการสั่งซื้อ
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="orderTable"
              >
                <thead>
                  <tr>
                    <th class="all" width="15%">Invoice NO.</th>
                    <th class="all" width="10%">Invoice Date.</th>
                    <th class="all">Vendor</th>
                    <th class="all" width="10%">รวมราคาสินค้า</th>
                    <!-- <th width="10%" class="center">สถานะ</th> -->
                    <th width="15%" class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import axios from "axios";
import datepicker from "../../../Shared/Datepicker";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

// let StatusActionsTrue = Vue.extend({
//   template: `
//   <div>
//     <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
//       <i class="fas fa-play"></i>เปิดใช้งาน
//     </a>
//   </div>`,
//   methods: {
//     editStatus: function() {
//       let self = this;
//       var table = $("#orderTable");
//       Swal.fire({
//         title: "คำสั่งแก้ไขสถานะ",
//         type: "warning",
//         html:
//           "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
//           "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
//         inputPlaceholder: "ต้องการแก้ไขสถานะ",
//         showCancelButton: true,
//         confirmButtonText: "ยืนยัน",
//         cancelButtonText: "ยกเลิก",
//         showLoaderOnConfirm: true
//       }).then(result => {
//         if (result.value === true || result.value === false) {
//           KTApp.blockPage({
//             opacity: 0.05,
//             message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
//           });

//           axios
//             .put("/Api/Stock/" + this.data.stockHeaderId + "/Toggle")
//             .then(function(response) {
//               if (response.data.data) {
//                 self.$parent.reloadDataTable();
//                 Swal.fire("สำเร็จ", response.data.message, "success");
//               } else {
//                 Swal.fire(
//                   "เกิดข้อผิดพลาด",
//                   error.response.data.message,
//                   "error"
//                 );
//               }
//             })
//             .catch(function(error) {
//               Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
//             })
//             .then(function() {
//               // always executed
//               KTApp.unblockPage();
//             });
//         }
//       });
//     }
//   }
// });
// let StatusActionsFalse = Vue.extend({
//   template: `
//   <div>
//     <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
//       <i class="fas fa-pause"></i>ปิดใช้งาน
//     </a>
//   </div>`,
//   methods: {
//     editStatus: function() {
//       let self = this;
//       var table = $("#orderTable");
//       Swal.fire({
//         title: "คำสั่งแก้ไขสถานะ",
//         type: "warning",
//         html:
//           "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
//           "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
//         inputPlaceholder: "ต้องการแก้ไขสถานะ",
//         showCancelButton: true,
//         confirmButtonText: "ยืนยัน",
//         cancelButtonText: "ยกเลิก",
//         showLoaderOnConfirm: true
//       }).then(result => {
//         if (result.value === true || result.value === false) {
//           KTApp.blockPage({
//             opacity: 0.05,
//             message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
//           });

//           axios
//             .put("/Api/Stock/" + this.data.stockHeaderId + "/Toggle")
//             .then(function(response) {
//               if (response.data.data) {
//                 self.$parent.reloadDataTable();
//                 Swal.fire("สำเร็จ", response.data.message, "success");
//               } else {
//                 Swal.fire(
//                   "เกิดข้อผิดพลาด",
//                   error.response.data.message,
//                   "error"
//                 );
//               }
//             })
//             .catch(function(error) {
//               Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
//             })
//             .then(function() {
//               // always executed
//               KTApp.unblockPage();
//             });
//         }
//       });
//     }
//   }
// });
let Action = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="detailStock" v-if="data.showDetailButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-file-text"></i>
    </a>
    <a href="#" @click.prevent="editStock" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
    <a href="#" @click.prevent="deleteStock" v-if="data.showDeleteButton" title="ลบ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    detailStock: function() {
      router.push({
        path: `/Master/Order/Detail/${this.data.stockHeaderId}`,
      });
    },
    editStock: function() {
      router.push({
        path: `/Master/Order/Edit/${this.data.stockHeaderId}`,
      });
    },
    deleteStock: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลการสั่งซื้อ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูลการสั่งซื้อ <strong>" +
          "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลการสั่งซื้อนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ลบข้อมูลการสั่งซื้อ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });
          axios
            .put("/Api/Stock/" + this.data.stockHeaderId + "/Delete")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    datepicker,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      orlKeyword: null,
      orlInvDate: null,
      //orlInActiveStatus: null,
      orlVendorId: [],
      orlQuotaId: [],
      orlProductId: [],
      //config
      // orlInActiveStatusOptions: {
      //   placeholder: "ทั้งหมด",
      //   allowClear: true,
      //   data: [
      //     { id: "false", text: "ใช้งาน", data: null },
      //     { id: "true", text: "ปิดใช้งาน", data: null }
      //   ]
      // },
      orlVendorIdOptions: [],
      // orlVendorIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Vendors/Select2Vendor",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      orlQuotaIdOptions: [],
      // orlQuotaIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Quota/Select2Quota",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      orlProductIdOptions: [],
      // orlProductIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Stock/Select2ProductStockItemQuery",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    formReset: function(e) {
      let self = this;
      self.orlKeyword = null;
      self.orlInvDate = null;
      self.orlVendorId = [];
      self.orlQuotaId = [];
      self.orlProductId = [];

      // $("#orlInActiveStatus")
      //   .val("")
      //   .trigger("change");

      $("#orlInvDate")
        .val("")
        .trigger("change");

      $("#orlVendorId")
        .val("")
        .trigger("change");

      $("#orlQuotaId")
        .val("")
        .trigger("change");

      $("#orlProductId")
        .val("")
        .trigger("change");
      self.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#orderTable").DataTable();
      table.search(this.id | this.name);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#orderTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    //LoadaOrlVendorIdOptions({ action, searchQuery, callback }) {
    LoadaOrlVendorIdOptions(inputdata=null) {
      var self = this;
      self.orlVendorIdOptions = [];

      if (inputdata) {
        if (inputdata.action === ASYNC_SEARCH) {
          axios
            .get("/Api/Vendors/Select2Vendor", {
              params: {
                page: 1,
                all: true,
                search: inputdata.searchQuery,
              },
            })
            .then(function(response) {
              if (response.status == 200) {
                var data = response.data.results;
                self.orlVendorIdOptions = [];
                data.forEach((element) => {
                  self.orlVendorIdOptions.push({
                    id: element.id,
                    label: element.text,
                  });
                });
              }
              inputdata.callback(null, self.orlVendorIdOptions);
            })
            .catch(function(error) {});
        }
      }
    },
    LoadaOrlQuotaIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Quota/Select2Quota", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.orlQuotaIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadaOrlProductIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Stock/Select2ProductStockItemQuery", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.orlProductIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    self.LoadaOrlVendorIdOptions();
    self.LoadaOrlQuotaIdOptions();
    self.LoadaOrlProductIdOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.orlInvDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.orlInvDate = moment();
    $(self.$refs.orlInvDate)
      //.datepicker("update", self.orlInvDate.format("DD/MM/YYYY"))
      .on("changeDate", function(e) {
        self.orlInvDate = moment(e.date);
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#orderTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Stock/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            //check for clear date value
            var idDate = $("#orlInvDate").val();
            if (idDate == null || idDate == "") self.orlInvDate = null;

            let jsonSearch = {
              SearchKeyword: self.orlKeyword,
              InvoiceDate:
                self.orlInvDate != null
                  ? self.orlInvDate.format("DD/MM/YYYY")
                  : self.orlInvDate,
              VendorId: self.orlVendorId,
              QuotaId: self.orlQuotaId,
              MaterialCode: self.orlProductId,
              //InActiveStatus: self.orlInActiveStatus
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[1, "desc"]],
        columns: [
          { data: "invoiceNo", className: "text-center" },
          {
            data: "invoiceDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.invoiceDateFormat;
            },
          },
          { data: "vendorName", className: "text-center" },
          {
            data: "summary",
            render: function(value) {
              return self.$options.filters.currency(value, "฿");
            },
            className: "text-center",
          },
          // {
          //   data: "inActiveStatus",
          //   className: "text-center",
          //   width: "10%",
          //   orderable: false,
          //   render: function(data, type, full, meta) {
          //     return '<div class="actionsStatus"></div>';
          //   }
          // },
          {
            data: "stockHeaderId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // $(".actionsStatus").each(function(i, el) {
        //   var $dt = table.DataTable();
        //   var $tr = $(el)
        //     .parents("tr")
        //     .first();
        //   var data = $dt.row($tr).data();
        //   if (data) {
        //     data.showEditStatusButton = self.$root.canShow(['MANAGE_MASTER', 'MANAGE_ORDER']);
        //     if (data.inActiveStatus == 0)
        //       new StatusActionsTrue({ data: { data }, parent: self }).$mount(
        //         el
        //       );
        //     else if (data.inActiveStatus == 1)
        //       new StatusActionsFalse({ data: { data }, parent: self }).$mount(
        //         el
        //       );
        //   }
        // });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          //console.log(data);
          if (data) {
            data.showDetailButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_ORDER",
            ]);
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_ORDER",
            ]);
            data.showDeleteButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_ORDER",
            ]);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    //table.trigger("draw.dt"); //call ajax delete this row
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Order/OrderList.vue